/**
 * Shared client-side auth constants.
 *
 * The auth tokens live in httpOnly cookies set by the backend and are never
 * accessible to JS. Only the non-sensitive user object is persisted client-side,
 * for optimistic hydration on reload (revalidated against /auth/me on boot).
 */

/** localStorage key holding the persisted (non-sensitive) user. */
export const AUTH_STORAGE_KEYS = {
  USER: "covaltechWebsite.auth.user",
} as const;
